import { USStateMapping } from '@rategravity/core-lib/enums';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import styles from '../styles/form';
import Autocomplete from './autocomplete';

export const CityStateAddress = ({ model, onChange, id }) => (
  <div>
    <div style={styles.row}>
      <Autocomplete
        className="private"
        value={model.get('city')}
        id={id}
        type="(cities)"
        floatingLabelText="City"
        onChange={onChange.bind(null, 'city')}
        onAutocomplete={({ city, state, zip, county }) => {
          onChange('city', city);
          onChange('state', state);
          onChange('county', county);
          onChange('zip', zip);
        }}
        placeTarget="city"
      />
      <SelectField
        maxHeight={300}
        labelStyle={{ paddingLeft: 0 }}
        underlineStyle={{ margin: '-1px 24px -1px 0' }}
        value={model.get('state')}
        floatingLabelText="State"
        onChange={(event, _, payload) => onChange('state', payload)}
      >
        {USStateMapping.map((state, i) => (
          <MenuItem key={i} value={state.abbreviation} primaryText={state.name} />
        ))}
      </SelectField>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/city-state-address.js